import React, { useState, useEffect } from 'react';
import { Card, Modal, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { CardContainer } from '../widgets/CardContainer';
import { Heading5, Form, Validator, Icon } from '../widgets';
import { FormValidator } from '../../helpers/form-validator';
import { getNetworkTypeList, addNetwork, getNetworkList } from '../../actions/networkType';
import { getUserId } from '../../helpers/session';
import networkIcon from '../../../assets/images/network-icon-black.svg';

const getRules = () => {
    const isSelect = (value) => { return (value === null) || (value === ""); }
    return ([
        {
            field: 'name',
            method: 'isEmpty',
            validWhen: false,
            message: 'Network Id is required.'
        },
        {
            field: 'networkEntityId',
            method: isSelect,
            validWhen: false,
            message: 'Network Type is required.'
        }
    ]);

}

const NetworkForms = ({ onHide, showModal, }) => {
    const dispatch = useDispatch();
    const validator = new FormValidator(getRules());

    const networkTypeList = useSelector((state) => state.network.networkTypeList);
    const [submitted, setSubmitted] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [state, setState] = useState({
        validation: validator.valid(),
        name: "",
        networkEntityId: "",
    });

    useEffect(() => {
        dispatch(getNetworkTypeList());
    }, [])

    const handleChange = (event) => {
        const { name, value } = event.target;
        setState({ ...state, [name]: value });
    };

    const handleSelect = (options, id) => {
        if (options) setState({ ...state, [id]: options.value });
        else setState({ ...state, [id]: null });
    }

    useEffect(() => {
        if (networkTypeList.length > 0) {
            setState({ ...state, networkEntityId: networkTypeList[0].entity_type_id })
        }
    }, [networkTypeList])

    const handleSubmit = () => {
        const s = state;
        const validation = validator.validate(s);

        setState({ ...state, validation });
        setSubmitted(true);
        if (validation.isValid) {
            const { networkEntityId, name } = state;
            const payload = {
                saved_by: getUserId(),
                entity_type_id: networkEntityId,
                network_name: name
            }
            const cb = (isSuccess) => {
                setIsSaving(false);
                if (isSuccess) {
                    dispatch(getNetworkList());
                    onHide();
                }
            }
            setIsSaving(true);

            dispatch(addNetwork(payload, cb));
        }
    }

    const s = state;
    const v = submitted ? validator.validate(state) : state.validation;

    return (
        <Modal show={showModal} onHide={onHide} backdrop="static" className="equipment-modal-form">
            <CardContainer className="form-container">
                <Card className="card-form border-0">
                    <Card.Header>
                        <Card.Title>
                            <div className='d-inline-flex align-items-center '>
                                <img src={networkIcon} className="network_icon" alt="network" />
                                <Heading5 className="m-0">
                                    Add Network
                                </Heading5>
                            </div>
                            <i className="fa fa-times close-btn" aria-hidden="true" title="close"
                                onClick={onHide} />
                        </Card.Title>
                    </Card.Header>
                    <Card.Body>
                        <Form autoComplete='off'>
                            <Form.Group>
                                <div className="mb-3">

                                    <Validator validation={v.networkEntityId}>
                                        <Form.Label htmlFor="networkType">Network Type<Validator.Mand /></Form.Label>
                                        <Form.Select
                                            id="networkEntityId"
                                            placeholder="Select Network Type"
                                            name="networkEntityId"
                                            onChange={(e) => handleSelect(e, "networkEntityId")}
                                            value={s.networkEntityId}
                                            options={networkTypeList && networkTypeList.map(e => {
                                                return ({ value: e.entity_type_id, label: e.entity_type_name });
                                            })}
                                        />
                                        <Validator.Text />
                                    </Validator>
                                </div>
                                <Validator validation={v.name}>
                                    <Form.Label htmlFor="name">Network Id<Validator.Mand /></Form.Label>
                                    <Form.Control type="text"
                                        id="name"
                                        name="name"
                                        placeholder="Enter the Network Id"
                                        maxLength='50'
                                        value={s.name}
                                        onChange={handleChange}
                                        autoComplete="off" />
                                    <Validator.Text />
                                </Validator>


                            </Form.Group>
                        </Form>
                    </Card.Body>
                </Card>
            </CardContainer>
            <Modal.Footer className='border-0'>
                <Button size="sm" variant="danger" onClick={onHide}>
                    <Icon className="fa fa-ban" /> Cancel
                </Button>
                <Button size="sm" variant="primary" onClick={() => handleSubmit()}>
                    <Icon className="fa fa-floppy-o" /> {isSaving ? " Adding..." : " Add"}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default NetworkForms;